import { ONEDRIVE_TOKEN_BASE_URL_FOR_ODB_PPE, ONEDRIVE_TOKEN_BASE_URL_FOR_ODB_PROD, ONEDRIVE_TOKEN_BASE_URL_FOR_ODP_PPE, ONEDRIVE_TOKEN_BASE_URL_FOR_ODP_PROD } from "../../AppConstants";
import { AuthEnvironment, IAuthenticationProvider, PrimaryIdentityInfo, IdentityType, GetAccessTokenOptions } from "../interfaces/IAuthenticationProvider";

export function OnedriveBaseUrlFromAuthEnvironment(environment: AuthEnvironment, identityType: IdentityType): string {
    switch (environment) {
        case AuthEnvironment.PPE:
            return OnedriveBaseUrlFromAuthEnvironmentForPPE(identityType);
        case AuthEnvironment.MSIT:
        case AuthEnvironment.Prod:
            return OnedriveBaseUrlFromAuthEnvironmentForProd(identityType);
        default:
            throw Error("Onedrive endpoint undefined for auth environment: " + environment + ", identityType = " + identityType);
    }
}

function OnedriveBaseUrlFromAuthEnvironmentForPPE(identityType: IdentityType): string {
    switch (identityType) {
        case IdentityType.ODB:
            return ONEDRIVE_TOKEN_BASE_URL_FOR_ODB_PPE;
        case IdentityType.ODP:
            return ONEDRIVE_TOKEN_BASE_URL_FOR_ODP_PPE;
        default:
        throw Error("Onedrive endpoint undefined for ppe environment with auth identityType: " + identityType);
    }
}

function OnedriveBaseUrlFromAuthEnvironmentForProd(identityType: IdentityType): string {
    switch (identityType) {
        case IdentityType.ODB:
            return ONEDRIVE_TOKEN_BASE_URL_FOR_ODB_PROD;
        case IdentityType.ODP:
            return ONEDRIVE_TOKEN_BASE_URL_FOR_ODP_PROD;
        default:
        throw Error("Onedrive endpoint undefined for prod environment with auth identityType: " + identityType);
    }
}

export function GetOnedriveToken(authProvider: IAuthenticationProvider, identityInfo: PrimaryIdentityInfo): Promise<string> {
    const onedriveBaseURL: string = OnedriveBaseUrlFromAuthEnvironment(authProvider.GetAuthEnvironment(), identityInfo.type);

    /** TODO: We may need to update this method to pass additional details of account identity to support win32
     platfrom, as in win32 multiple accounts can be simultaneouly loggedin.
     Current implementation will work fine for web transcription experience. */

    const options: GetAccessTokenOptions = { resource: onedriveBaseURL };
    return authProvider.GetAccessToken(options);
}